import { FC, useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Stack,
  SystemProps,
  Text,
} from "@storyofams/react-ui";
import Image from "next/image";
import { useRouter } from "next/router";
import { useShopify } from "~context";
import { Info } from "~components/common/Icons";
import { Modal } from "~components/common/Modal";
import { ProductByHandleQuery } from "~lib/shopify/sdk";
import { shopifyToIntlPrice } from "~lib/shopify/utils";
import { BackInStock } from "../ActionPanel/BackInStock";
import { Label } from "./Label";
import { OptionPrice } from "./OptionPrice";
interface SingleVariant extends SystemProps {
  option: ProductByHandleQuery["productByHandle"]["variants"]["edges"][0]["node"];
  mostPopularVariant?: string;
  autoDiscount: string | null;
}

export const SingleVariant: FC<SingleVariant> = ({
  option,
  mostPopularVariant,
  autoDiscount,
  ...props
}) => {
  const { query, replace } = useRouter();
  const { customerCompanyId, isB2B } = useShopify();
  const [isPricesVisible, setIsPricesVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const isPicked = option.id.includes(query.variantId as string);
  const isDisabled = !option.availableForSale;
  const isPopular = option.id === mostPopularVariant;
  const title = option.selectedOptions[option.selectedOptions.length - 1].value;
  const handleImageClick = () => setIsOpen(true);
  return (
    <Box width="100%" {...props}>
      <Box
        as="button"
        // cursor={isDisabled && "not-allowed"}
        width={"100%"}
        py={["7px", "11px"]}
        px={["6px", "16px"]}
        border={
          isPicked && !isDisabled ? "1px solid #1D1D1B" : "1px solid #E2DFDF"
        }
        borderRadius={"8px"}
        position={"relative"}
        // disabled={isDisabled}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          const route = {
            query: {
              ...query,
              variantId: option.id.replace(/gid:\/\/shopify\/.*\//i, ""),
            },
          };
          replace(route, undefined, { shallow: true });
        }}
      >
        <Box
          width={"100%"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          fontSize={2}
        >
          <Flex alignItems={"center"}>
            <Box
              width={16}
              border="1px solid black"
              height={16}
              borderRadius={"full"}
              display={"flex"}
              alignItems={"center"}
              flexShrink={1}
              justifyContent={"center"}
              mr={1}
            >
              {isPicked && (
                <Box
                  width={6}
                  border="1px solid black"
                  height={6}
                  backgroundColor={"black"}
                  borderRadius={"full"}
                />
              )}
            </Box>
            <Flex
              alignItems={["start", "center"]}
              flexDirection={["column", "row"]}
            >
              <Flex alignItems={"center"} position={"relative"}>
                <Text
                  textAlign={"start"}
                  fontSize={2}
                  lineHeight={["16px", "22px"]}
                  fontWeight={600}
                  mr={0.5}
                >
                  {title}
                </Text>
                {customerCompanyId &&
                  isB2B &&
                  option.quantityPriceBreaks.nodes &&
                  !!option.quantityPriceBreaks.nodes.length && (
                    <Icon
                      fontSize={"16px"}
                      onMouseOver={() => setIsPricesVisible(true)}
                      onMouseLeave={() => setIsPricesVisible(false)}
                      icon={Info}
                    ></Icon>
                  )}
                {isPricesVisible && (
                  <Box
                    p={1}
                    bg="#C39A91"
                    borderRadius={"4px"}
                    position={"absolute"}
                    color="white"
                    transform={["translate(50%, 72%)", "translate(105%, 72%)"]}
                    right={0}
                    zIndex={100}
                    width={["180px", "252px"]}
                    lineHeight={"20px"}
                    fontSize={"14px"}
                  >
                    <Stack
                      borderBottom={"1px solid #FFFFFF30"}
                      space={0}
                      justifyContent={"space-between"}
                      fontWeight={600}
                    >
                      <Text>Min: 6</Text>
                      <Text>Per: 6</Text>
                      <Text>Max: 100</Text>
                    </Stack>
                    {option.quantityPriceBreaks.nodes.map((item, i) => (
                      <Flex py={0.5} justifyContent={"space-between"} key={i}>
                        <Text>{`${item.minimumQuantity} pieces`}</Text>
                        <Text>{`${shopifyToIntlPrice(item.price)}/ea`}</Text>
                      </Flex>
                    ))}
                  </Box>
                )}
              </Flex>

              {(isPopular || isDisabled) && (
                <Label ml={[0, 1]} mt={["4px", 0]} isOutOfStock={isDisabled} />
              )}
            </Flex>
          </Flex>

          <Stack space={1} alignItems={"center"}>
            <OptionPrice option={option} autoDiscount={autoDiscount} />{" "}
            <Box
              border={
                isPicked && !isDisabled
                  ? "1px solid #1D1D1B"
                  : "1px solid #E2DFDF"
              }
              borderRadius={"8px"}
              overflow={"hidden"}
              position={"relative"}
              opacity={isDisabled ? 0.5 : 1}
              display={["block", "none"]}
              width={40}
              height={40}
              onClick={handleImageClick}
            >
              <Image layout="fill" src={option.smallImage.url}></Image>
            </Box>
          </Stack>
        </Box>
        {isDisabled && isPicked && (
          <BackInStock id={option.product.id} variantId={option.id} />
        )}
      </Box>
      <Modal isOpen={isOpen} close={() => setIsOpen(false)}>
        <Box width={"100%"} p={2} height={"40vh"}>
          <Box width={"100%"} height={"100%"} position={"relative"}>
            <Image
              objectFit="contain"
              layout="fill"
              src={option.image.url}
              quality={50}
              blurDataURL={option.image.url}
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
